<ng-container *ngIf="{label: label$ | async} as data">
    <div class="loading-screen m-3 m-md-5 d-flex justify-content-end align-items-center"
         @bounce
         *ngIf="data.label !== null">
        <span class="loading-screen-label me-2" *ngIf="data.label.length > 0">{{data.label}}</span>
        <img class="loading-screen-spinner" src="/assets/img/auxi/logo.svg" alt="Nirby Spinner">
    </div>
</ng-container>
